export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const localeAppPath = (path) => {
    const { locale, defaultLocale } = nuxtApp.$i18n
    const lang = locale.value == defaultLocale ? '' : `/${locale.value}`
    return `${config.public.appUrl}${lang}${path}`
  }

  nuxtApp.provide('localeAppPath', localeAppPath)
})
